<script setup lang="ts">
import { ref, watch, onMounted } from "vue";
import { Permission } from "../../../../../types/auth";
import { FilterField, TableField } from "../../../../../components/table/table";
import ListTemplate from "../../../../../components/ui/common/ListTemplate.vue";
import AddListItemForm from "../../variants/AddListItemForm.vue";
import Buttons from "../../../../../components/ui/form/Buttons.vue";
import DropDownButton from "../../../../../components/ui/common/DropDownButton.vue";
import { api } from "../../../../../api/Api";

const props = defineProps<{
  data?: any | [];
  permissions?: Permission[];
  item: any | null;
  variant: any | null;
}>();

const endPoint = "/clients/inventory/item-management/variants/";
const selectedData = ref<any | null>(null);
const showForm = ref(false);
const formMode = ref<
  "create" | "edit" | "view" | "showQuickView" | "toggleStatus"
>("view");
const refreshData = ref(false);

const rows = ref<any[]>(props.data);

const fields: TableField[] = [
{
    name: "photo",
    caption: "Photo",
    sortable: false,
    fieldType: "image",
  },
  {
    name: "code",
    caption: "Code",
    sortable: true,
    fieldType: "text",
  },
  {
    name: "name",
    caption: "Variant Name",
    sortable: true,
    fieldType: "text",
  },
  { name: "active", caption: "active", sortable: false, fieldType: "status" },
];

const filterFields: FilterField[] = [
  {
    name: "active",
    label: "Status",
    type: "select",
    value: "",
    options: [
      { id: "1", name: "Active" },
      { id: "0", name: "Inactive" },
    ],
  },
];

const changeMode = (
  mode: "create" | "edit" | "view" | "showQuickView" | "toggleStatus", item: any
) => {
  selectedData.value = item;
  console.log('item', item);
  console.log('selectedData', selectedData.value);
  console.log("changeMode", mode);
  formMode.value = mode;
  showForm.value = mode === "view" || mode === "edit" || mode === "create";
};

const handleData = (data: any) => {
  selectedData.value = data;
};

const handleListAdded = async (data: any) => {
  rows.value = data.variant_list[0].list;
  showForm.value = false;
};

const handleCreate = () => {
  selectedData.value = null;
  formMode.value = "create";
  showForm.value = true;
};

const variantList = ref<any[]>([]);

const handleGetVariants = async () => {
  if (props.item) {
    const response = await api.post('/clients/inventory/item-management/variants/list-get',
        {
            variants_id: props.variant?.id,
        }
    );
    if (response.success == true) {
        variantList.value = response.data.filter(
          (e: any) => !props.data?.list.some((item: any) => item.variant_lists_id === e.id)
        );
    }    
  }
};


const handleAssignVariant = async (data: any) => {
  selectedData.value = data;
  showForm.value = true;
  formMode.value = "view";
  return;
  if (data) {
    const response = await api.post('/clients/inventory/item-management/items/variant-create',
        {
            items_id: props.item.id,
            variants_id: data.variants_id,
            variant_lists_id: data.id,
            code: data.code,
            photo: data.photo,
            name: data.name,
        }
    );
    if (response.success == true) {
        rows.value = response.data.variant_list[0].list;
    }
  }
}

const handleUpdateAssignVariant = async (data: any) => {
  if (data) {
    const response = await api.post('/clients/inventory/item-management/items/variant-create',
        {
            items_id: props.item.id,
            variants_id: data.variants_id,
            variant_lists_id: data.id,
            code: data.code,
            photo: data.photo,
            name: data.name,
        }
    );
    if (response.success == true) {
        rows.value = response.data.variant_list[0].list;
        showForm.value = false;
    }
  }
}

onMounted(() => {
  rows.value = props.data?.list;
  handleGetVariants();
});

watch(
  () => props.data,
  () => {
    rows.value = props.data;
  },
  { immediate: true }
);
</script>

<template>
  <ListTemplate
    :endPoint="endPoint"
    :title="props.data?.name"
    :fields="fields"
    :actions="[]"
    :filterFields="filterFields"
    :tabList="[]"
    :refreshData="refreshData"
    @mode="changeMode"
    @show="showForm = true"
    :showForm="showForm"
    @data="handleData"
    :permissions="permissions"
    :ignore-permissions="true"
    :data="rows"
    :remote="false"
    :showHeader="false"
    :showQuickTour="false"
    :showQuickView="false"
    :showPagination="false"
    :allowDisable="true"
    :show-actions="true"
    :ignore-max-height="true"
  >
  <template #header-actions>
      <Buttons icon="Plus" caption="New Variant Item" @click="handleCreate" />
      <DropDownButton
        key="action-dropdown-sales"
        id="actions-dropdown-sales"
        text="Assign Variant"
        icon="Shapes"
        v-if="variantList.length > 0">
        <Buttons 
          v-for="(item, index) in variantList"
          :key="index"
          class='w-full px-1 py-2 text-sm text-left text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700'
          :caption="item.name"
          @click="handleAssignVariant(item)" />
        </DropDownButton>
    </template>
    <template #form-view> </template>
  </ListTemplate>
  <AddListItemForm
    title="Variant List"
    :variant="data"
    :permissions="permissions"
    :data="selectedData"
    endPoint="/clients/inventory/item-management/items/"
    :mode="formMode"
    :item="props.item"
    @close="showForm = false"
    @assign="handleUpdateAssignVariant"
    @save="handleListAdded"
    v-if="showForm"
  />
</template>
